// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont_info_cis{
    position: relative;
    display: block;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
.top_info_cis{
    position: relative;
    display: block;
    height: 35%;
    width: 100%;
}
.row_info_cis{
    position: relative;
    width: 100%;
    height: 20%;
    display: flex;
    justify-content: start;
    align-items: center;
}
.row_info_cis:nth-child(odd){
    background-color: #f8f9fa;
  }
  .row_info_cis:nth-child(even){
    background-color: #eeeeee;
  }
.title-info_cis{
    position: relative;
    width: 13%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bolder;
    color: #003757d3;
    font-size: large;
}
.txt-info_cis{
    position: relative;
    width: 87%;
    height: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    color: #414141;
    font-size: medium;
}
.cel_row_info_cis{
        position: relative;
        display: flex;
        width: 25%;
        height: 100%;
}
.cel_row_info_cis:nth-child(even){
    background-color: #f8f9fa;
  }
  .cel_row_info_cis:nth-child(odd){
    background-color: #eeeeee;
  }

  .body_info_cis-gs{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 80%;
  }
  .body-table-cis-gs{
    width: 100%;
    position: relative;
    display: block;
    justify-content: center;
    align-items: center;
    height: 90%;
    overflow: 'auto';
  }
  .actBlanco {
    height: 4vh !important;
  }
  

  .info-cis-action:hover{
cursor: pointer;
  }`, "",{"version":3,"sources":["webpack://./src/components/provicionamiento-componentes/styles/InfoCis.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;AACF;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;AACrB;AACA;QACQ,kBAAkB;QAClB,aAAa;QACb,UAAU;QACV,YAAY;AACpB;AACA;IACI,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;EACb;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;;;EAGA;AACF,eAAe;EACb","sourcesContent":[".cont_info_cis{\n    position: relative;\n    display: block;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n.top_info_cis{\n    position: relative;\n    display: block;\n    height: 35%;\n    width: 100%;\n}\n.row_info_cis{\n    position: relative;\n    width: 100%;\n    height: 20%;\n    display: flex;\n    justify-content: start;\n    align-items: center;\n}\n.row_info_cis:nth-child(odd){\n    background-color: #f8f9fa;\n  }\n  .row_info_cis:nth-child(even){\n    background-color: #eeeeee;\n  }\n.title-info_cis{\n    position: relative;\n    width: 13%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bolder;\n    color: #003757d3;\n    font-size: large;\n}\n.txt-info_cis{\n    position: relative;\n    width: 87%;\n    height: 100%;\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    color: #414141;\n    font-size: medium;\n}\n.cel_row_info_cis{\n        position: relative;\n        display: flex;\n        width: 25%;\n        height: 100%;\n}\n.cel_row_info_cis:nth-child(even){\n    background-color: #f8f9fa;\n  }\n  .cel_row_info_cis:nth-child(odd){\n    background-color: #eeeeee;\n  }\n\n  .body_info_cis-gs{\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 80%;\n  }\n  .body-table-cis-gs{\n    width: 100%;\n    position: relative;\n    display: block;\n    justify-content: center;\n    align-items: center;\n    height: 90%;\n    overflow: 'auto';\n  }\n  .actBlanco {\n    height: 4vh !important;\n  }\n  \n\n  .info-cis-action:hover{\ncursor: pointer;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
